<template>
  <div class="wrapper">
    <Loader :is-visible="loading" />
    <SubstitutionListFilters
      @applyFilters="applyFilters"
      @fetchSubstitutions="fetchSubstitutions"
    />

    <div class="card">
      <div class="card-header">
        <i class="icon-refresh"></i> Demandes de remplacements
      </div>

      <div class="card-block">
        <Tabs v-model="activeTab">
          <Tab :header="pendingHeader">
            <Substitutions
              :substitutions="pending"
              status="pending"
              @treated="substitutionTreated"
              @rejected="substitutionRejected"
              @notebookNoteAdded="substitutionOrderNotebookAdded"
              @notebookNoteUpdated="substitutionOrderNotebookUpdated"
              @notebookNoteDeleted="substitutionOrderNotebookDeleted"
            />
          </Tab>
          <Tab :header="treatedHeader">
            <Substitutions
              :substitutions="treated"
              status="treated"
              @archived="substitutionArchived"
              @notebookNoteAdded="substitutionOrderNotebookAdded"
              @notebookNoteUpdated="substitutionOrderNotebookUpdated"
              @notebookNoteDeleted="substitutionOrderNotebookDeleted"
            />
          </Tab>
          <Tab :header="rejectedHeader">
            <Substitutions
              :substitutions="rejected"
              status="rejected"
              @archived="substitutionArchived"
              @notebookNoteAdded="substitutionOrderNotebookAdded"
              @notebookNoteUpdated="substitutionOrderNotebookUpdated"
              @notebookNoteDeleted="substitutionOrderNotebookDeleted"
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Substitutions from "@/components/coach/Substitutions";
import SubstitutionListFilters from "@/components/coach/SubstitutionListFilters";
import Loader from "@/components/utils/Loader";
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Substitutions,
    SubstitutionListFilters,
    Loader,
    Tabs,
    Tab,
  },
  data() {
    return {
      loading: false,
      filters: {
        start: null,
        coachManager: [],
        type: [],
        name: "",
      },
      substitutions: null,
      activeTab: 0,
      modalUpdateComment: {
        showComment: false,
        commentaireSubstitution: null,
      },
    };
  },
  computed: {
    pending() {
      return this.substitutions?.filter((s) => !s.treated && !s.rejected) || [];
    },
    treated() {
      return this.substitutions?.filter((s) => s.treated) || [];
    },
    rejected() {
      return this.substitutions?.filter((s) => s.rejected) || [];
    },
    pendingHeader() {
      return `A traiter ${
        !this.loading && this.substitutions ? `(${this.pending.length})` : ""
      }`;
    },
    treatedHeader() {
      return `Validées ${
        !this.loading && this.substitutions ? `(${this.treated.length})` : ""
      }`;
    },
    rejectedHeader() {
      return `Refusées ${
        !this.loading && this.substitutions ? `(${this.rejected.length})` : ""
      }`;
    },
  },

  methods: {
    async fetchSubstitutions() {
      try {
        this.loading = true;

        const { data } = await this.$api.get("/substitutions", {
          params: this.filters,
        });

        this.substitutions = data;
      } catch (e) {
        this.$errorToast("Impossible de charger les demandes de remplacements");
      } finally {
        this.loading = false;
      }
    },

    applyFilters(form) {
      this.filters = {
        ...this.filters,
        ...form,
      };

      this.fetchSubstitutions();
    },

    substitutionTreated(substitutionId) {
      if (!this.substitutions) {
        return;
      }

      this.substitutions = this.substitutions.map((s) =>
        s.id === substitutionId
          ? { ...s, treated: true, treatedAt: new Date() }
          : s,
      );
    },

    substitutionRejected(substitutionId, rejectedReason) {
      if (!this.substitutions) {
        return;
      }

      this.substitutions = this.substitutions.map((s) =>
        s.id === substitutionId
          ? { ...s, rejected: true, rejectedReason, rejectedAt: new Date() }
          : s,
      );
    },

    substitutionArchived(substitutionId) {
      if (!this.substitutions) {
        return;
      }

      this.substitutions = this.substitutions.filter(
        (s) => s.id !== substitutionId,
      );
    },

    substitutionOrderNotebookAdded({ orderId, note }) {
      if (!this.substitutions) {
        return;
      }

      this.substitutions = this.substitutions.map((s) => ({
        ...s,
        orders: s.orders.map((o) =>
          o.id === orderId ? { ...o, notebook: [note, ...o.notebook] } : o,
        ),
      }));
    },

    substitutionOrderNotebookUpdated({ orderId, note }) {
      if (!this.substitutions) {
        return;
      }

      this.substitutions = this.substitutions.map((s) => ({
        ...s,
        orders: s.orders.map((o) =>
          o.id === orderId
            ? {
                ...o,
                notebook: o.notebook.map((n) =>
                  n.id === note.id ? { ...n, ...note } : n,
                ),
              }
            : o,
        ),
      }));
    },

    substitutionOrderNotebookDeleted({ orderId, noteId }) {
      if (!this.substitutions) {
        return;
      }

      this.substitutions = this.substitutions.map((s) => ({
        ...s,
        orders: s.orders.map((o) =>
          o.id === orderId
            ? {
                ...o,
                notebook: o.notebook.filter((n) => n.id !== noteId),
              }
            : o,
        ),
      }));
    },
  },
};
</script>
